module.exports = __webpack_public_path__ + "img/okta.e0da7b16.svg";